import { createReducer, on } from '@ngrx/store';

import { UIStatesEnum, PaginationModel } from 'common/src/models';
import { FilterModelNew } from '../../../outgoing-invoice/models/filter-model-new';
import { ScheduledPaymentBillingPeriodModel, ScheduledPaymentModel } from '../../models';
import { CollectionScheduledPaymentActions } from '../actions/action-types';
import { ScheduledPaymentListTabsEnum } from '../../enums';
import { CurrencyModel } from '../../../payment/models/currency.model';

export const ScheduledPaymentFeatureKey = 'scheduledPaymentStore';

export interface SchedulesPaymentsListState {
  [page: string]: {
    pagination: PaginationModel;
    sort: FilterModelNew;
    data: ScheduledPaymentModel[];
  }
}
export interface ScheduledPaymentsState {
  [ScheduledPaymentListTabsEnum.DRAFT]?: SchedulesPaymentsListState;
  [ScheduledPaymentListTabsEnum.OPEN]?: SchedulesPaymentsListState;
  [ScheduledPaymentListTabsEnum.COMPLETED]?: SchedulesPaymentsListState;
  [ScheduledPaymentListTabsEnum.CANCELED]?: SchedulesPaymentsListState;
  [ScheduledPaymentListTabsEnum.DELETED]?: SchedulesPaymentsListState;
  [ScheduledPaymentListTabsEnum.ALL]?: SchedulesPaymentsListState;
}

export interface ScheduledPaymentsStore {
  entity: ScheduledPaymentState;
  list: ScheduledPaymentsState;
  blocksValidations: ScheduledPaymentBlocksValidationsState;
}

export interface ScheduledPaymentState {
  scheduledPayment: ScheduledPaymentModel;
  currentState: UIStatesEnum;
  currencies: CurrencyModel[];
  attachmentsCount: number;
  loadingRequestsCount: number;
  updatedAt: Date;
  isShouldRefresh: boolean;
  syncPeriods: { sync: boolean };
  periods: ScheduledPaymentBillingPeriodModel[];
}

export const initialScheduledPaymentState: ScheduledPaymentState = {
  scheduledPayment: {} as ScheduledPaymentModel,
  currentState: UIStatesEnum.VIEW,
  currencies: [],
  attachmentsCount: 0,
  loadingRequestsCount: 0,
  updatedAt: null,
  isShouldRefresh: false,
  syncPeriods: null,
  periods: []
};

export const initialScheduledPaymentsState: ScheduledPaymentsState = {
  [ScheduledPaymentListTabsEnum.DRAFT]: {},
  [ScheduledPaymentListTabsEnum.OPEN]: {},
  [ScheduledPaymentListTabsEnum.COMPLETED]: {},
  [ScheduledPaymentListTabsEnum.CANCELED]: {},
  [ScheduledPaymentListTabsEnum.DELETED]: {},
  [ScheduledPaymentListTabsEnum.ALL]: {},
}

export interface ScheduledPaymentBlocksValidationsState {
  propertiesBlockValid: boolean;
  billingInfoBlockValid: boolean;
  positionsBlockValid: boolean;
}

export const initialScheduledPaymentBlocksValidationsState: ScheduledPaymentBlocksValidationsState = {
  propertiesBlockValid: false,
  billingInfoBlockValid: false,
  positionsBlockValid: false,
};

export function ScheduledPaymentReducer(state, action) {
  return _ScheduledPaymentReducer(state, action);
}

export function ScheduledPaymentsListReducer(state, action) {
  return _ScheduledPaymentsListReducer(state, action);
}

export function ScheduledPaymentBlocksValidationsReducer(state, action) {
  return _ScheduledPaymentBlocksValidationsReducer(state, action);
}

const _ScheduledPaymentBlocksValidationsReducer = createReducer(
  initialScheduledPaymentBlocksValidationsState,
  on(CollectionScheduledPaymentActions.UpdatePropertiesBlockValid, (state, { propertiesBlockValid }) => ({
    ...state,
    propertiesBlockValid
  })),
  on(CollectionScheduledPaymentActions.UpdateBillingInfoBlockValid, (state, { billingInfoBlockValid }) => ({
    ...state,
    billingInfoBlockValid
  })),
  on(CollectionScheduledPaymentActions.UpdatePositionsBlockValid, (state, { positionsBlockValid }) => ({
    ...state,
    positionsBlockValid
  })),
);

const _ScheduledPaymentsListReducer = createReducer(
  initialScheduledPaymentsState,
  on(CollectionScheduledPaymentActions.LoadScheduledPaymentsList, (state, { scheduledPaymentListData, status, page }) => ({
    ...state,
    [status]: {
      ...state[status],
      ...scheduledPaymentListData
    },
  })),
);

const _ScheduledPaymentReducer = createReducer(
  initialScheduledPaymentState,
  on(CollectionScheduledPaymentActions.LoadScheduledPayment, (state, { scheduledPayment }) => ({
    ...state,
    scheduledPayment: scheduledPayment,
  })),
  on(CollectionScheduledPaymentActions.UpdateScheduledPaymentState, (state, { currentState }) => ({
    ...state,
    currentState,
  })),
  on(CollectionScheduledPaymentActions.LoadCurrencies, (state, { currencies }) => ({
    ...state,
    currencies,
  })),
  on(CollectionScheduledPaymentActions.LoadScheduledPaymentPeriods, (state, { periods }) => ({
    ...state,
    periods,
  })),
  on(CollectionScheduledPaymentActions.UpdateScheduledPaymentAttachmentsCount, (state, { attachmentsCount }) => ({
    ...state,
    attachmentsCount,
  })),
  on(CollectionScheduledPaymentActions.UpdateScheduledPaymentUpdatedAt, (state, { updatedAt }) => ({
    ...state,
    updatedAt,
  })),
  on(CollectionScheduledPaymentActions.UpdateShouldRefreshEntity, (state, { isShouldRefresh }) => ({
    ...state,
    isShouldRefresh,
  })),
  on(CollectionScheduledPaymentActions.UpdateScheduledPaymentSyncPeriods, (state, { syncPeriods }) => ({
    ...state,
    syncPeriods,
  })),
  on(CollectionScheduledPaymentActions.ClearScheduledPaymentUpdatedAt, (state) => ({
    ...state,
    updatedAt: null,
  })),
  on(CollectionScheduledPaymentActions.IncrementLoadingRequestsCount, (state) => ({
    ...state,
    loadingRequestsCount: state.loadingRequestsCount + 1,
  })),
  on(CollectionScheduledPaymentActions.DecrementLoadingRequestsCount, (state) => ({
    ...state,
    loadingRequestsCount: state.loadingRequestsCount - 1,
  })),
);
